import React from 'react';

const UserRoleDropdown = ({ items, selectItem, label, setOpenDropdown, openDropdown }) => {
  const open = openDropdown === 'user-role';

  function handleClickOpen(e) {
    if (open) {
      setOpenDropdown(null);
    } else {
      setOpenDropdown('user-role');
    }
    e.stopPropagation();
  }

  const content = open ? (
    <div className="dropdown-menu">
      <div className="user-role-dropdown">
        {items.map((item, idx) => {
          const itemLabel = item.label.split(' ')[0].toLowerCase();

          return (
            <li key={idx} className={`dropdown-item ${itemLabel}`} onClick={() => selectItem(idx)}>
              <span>{item.label}</span>
            </li>
          );
        })}
      </div>
    </div>
  ) : null;

  return (
    <div className={`dropdown-wrapper ${open ? 'open' : ''}`} onClick={handleClickOpen}>
      {content}
      <div className="label">
        <span className="label-text">{label}</span>
        <span className={open ? 'arrow-up' : 'arrow-down'} />
      </div>
    </div>
  );
};

export default UserRoleDropdown;
